import { render, staticRenderFns } from "./CardTarjaBigPoolDay.vue?vue&type=template&id=03aebb93&scoped=true"
import script from "./CardTarjaBigPoolDay.vue?vue&type=script&lang=js"
export * from "./CardTarjaBigPoolDay.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaBigPoolDay.vue?vue&type=style&index=0&id=03aebb93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aebb93",
  null
  
)

export default component.exports